import React from 'react';

function CompanyFilterSelect({
  companies,
  selectedCompanyId,
  onChange,
  id = 'company-filter',
  showAll = true,
  variant = 'list',
}) {
  if (companies.length === 0) {
    return null;
  }

  const labelClassName = variant === 'financials' ? 'financials-filter-label' : 'list-filter-label';
  const selectClassName = variant === 'financials' ? 'financials-company-filter-select' : 'list-filter-select';
  const fieldClassName = variant === 'financials' ? 'financials-filter-field' : 'list-company-filter-field';

  return (
    <div className={fieldClassName}>
      <label htmlFor={id} className={labelClassName}>
        Company:
      </label>
      <select
        id={id}
        value={selectedCompanyId}
        onChange={onChange}
        className={selectClassName}
      >
        {showAll && <option value="">All</option>}
        {companies.map((company) => (
          <option key={company.id} value={String(company.id)}>
            {company.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CompanyFilterSelect;
